import React from 'react';

export function FileUploadIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48" id="upload">
      <path fill="none" d="M0 0h48v48H0z"></path>
      <path d="M18 32h12V20h8L24 6 10 20h8zm-8 4h28v4H10z"></path>
    </svg>
  );
}
